import { Injectable, Input } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const EmphasisMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Emphasis extends Clazz {
    @Input()
    public emphasis: "bold" | "subtle" = "bold";

    get bold(): boolean {
      return this.emphasis === "bold";
    }

    get subtle(): boolean {
      return this.emphasis === "subtle";
    }
  }

  return Emphasis;
};
export const EmphasisMixinInputs = ["emphasis"];
